// client/src/coms/views/games_parts/UserAvatar.js
import React, { useState } from 'react';
import { avatarSrc, markAvatarFailed } from './avatarSources';

function initials(name) {
  const parts = String(name || '?').trim().split(/\s+/).filter(Boolean);
  return (parts.length > 1 ? parts[0][0] + parts[1][0] : String(name || '?').slice(0, 2)).toUpperCase();
}

// The user's Voxemera avatar, falling back to initials when they have none.
export default function UserAvatar({ userId, name, size = 28 }) {
  const [failed, setFailed] = useState(false);
  const src = avatarSrc(userId);
  const box = { width: size, height: size, borderRadius: '50%', flex: '0 0 auto' };
  const onError = () => {
    markAvatarFailed(src);
    setFailed(true);
  };
  if (src && !failed) {
    return <img src={src} alt="" style={{ ...box, objectFit: 'cover', background: 'var(--vxs-5, #2b2d31)' }} onError={onError} />;
  }
  return (
    <span aria-hidden="true" style={{ ...box, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'var(--vx-accent, #5865f2)', color: 'var(--vx-on-accent, #fff)', fontSize: Math.round(size * 0.38), fontWeight: 900 }}>
      {initials(name)}
    </span>
  );
}
